import React, {useEffect, useRef, useState} from 'react';
import "../Store/Store.scss";
import SimpleLineIcon from "react-simple-line-icons";
import Swiper from 'react-id-swiper';
import 'swiper/swiper-bundle.css';
import {Nav} from "../../Components";
import {useHistory, useLocation} from "react-router-dom";
import {ServiceList_api, ServiceTags_api} from "./ChartServices";



function StoreCard({item}) {


    const history = useHistory();

    const gotToDetail= merchant => history.push(`/service-detail/${item.uid}`,{merchant})

    return(
        <div style={{position: 'relative'}} >
            <div key={item.uid} className="store-item" onClick={()=>gotToDetail(item)}>
                <div className="store-item-info">
                    <span className="store-item-name">{item.title}</span>
                    <span className="store-item-cat">{item.subtitle}</span>
                </div>
                <div className="store-item-img">
                    <img src={item.cover} alt=""/>
                </div>
            </div>
        </div>
    )
}


function Chart() {


    const MyRef = useRef(null);
    const location = useLocation()



    const params = {
        slidesPerView: 'auto',
        spaceBetween: 15,
        // rebuildOnUpdate : true,
        rtl:true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        }
    }

    const [preload,setPreload] = useState(true);
    const [failed,setFailed] = useState(false);
    const [search,setSearch] = useState("");

    const [cats,setCats] = useState([])
    const [originalList,setOriginalList] = useState([])
    const [list,setList] = useState([])
    const [currentCat,set_currentCat] = useState([])



    const updateSlider = () =>{
        MyRef.current.swiper.update();
    }

    const getStore = async (tagId=null) => {
        setPreload(true);
        try{
            const res = await ServiceList_api(tagId)
            setList(res.data)
            updateSlider();
            setPreload(false);
        }catch (e) {
            setPreload(false);
        }
    }






    const getCat = async () => {
        try{
            const response = await ServiceTags_api();
            setCats(response.data);
            setPreload(false);
        }catch (e) {
            setPreload(false);
        }
    }

    const selectCat = (tag)=>{
        if(tag.uid!==1)
            getStore(tag.uid)
        else
            getStore()
    }

    useEffect(()=>{
        getStore()
        getCat();
    },[])




    return(
        <div className="store-container">
            {/*Header*/}
            <div className="customer-header">
                <span>{"چارت"}</span>
            </div>
            <div className="store-head">
                <div className="store-categories">
                    {/*OnlineStoreSubCat List*/}
                    <div className="store-categories-list">
                        {cats.length>0?  <Swiper ref={MyRef}  {...params}>
                            <div key={1}
                                 onClick={()=>{selectCat({uid:1})}}
                                 className="store-categories-item">
                                    <span className={currentCat.uid===1?"cat_select":"cat_deselect"}>همه
                                        {/*<i className="fa fa-user"></i>*/}
                                    </span>
                                <img src={"https://test-loyalty-minio.darkube.app/loyalty-media/merchant/category/images/poshak.png"}  alt="" style={{width:'100%'}}/>
                            </div>
                            {cats.map(cat=>{
                                return (
                                    <div key={cat.uid}
                                         onClick={()=>{selectCat(cat)}}
                                         className="store-categories-item">
                                    <span className={currentCat.uid===cat.uid?"cat_select":"cat_deselect"}>{cat.name}
                                        {/*<i className="fa fa-user"></i>*/}
                                    </span>
                                        <img src={cat.image}  alt="" style={{width:'100%'}}/>
                                    </div>
                                )
                            })}
                        </Swiper>:null}
                    </div>
                </div>
            </div>

            <br/>
            <div className="store-body">
                {/* OnStore List*/}
                {!preload?<div className="store-list" style={{paddingBottom:100}}>
                    {list.map(item=>{
                            return <StoreCard key={item.uid} item={item}/>;
                    })}
                </div>:<div className="customer-preLoading">
                    {!failed?<div className="customer-preloading-body">
                        <img src="/svg/pre.gif" alt=""/>
                    </div>:<div className="customer-failed-body">
                        <img src="/svg/failed.svg" alt=""/>
                        <span>اطلاعاتی موجود نیست</span>
                    </div>}
                </div>}
            </div>
            <Nav/>
        </div>
    )
}

export {Chart};
